import { dataTransferWrap } from './../dataTransferService';
import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getWorksQualityNorms(companyId, cashedPayload) {
    return dataTransferWrap(
        ModulesMap.WORKS_QUALITY_NORMS,dtConfig[ModulesMap.WORKS_QUALITY_NORMS].getWorksQualityNorms,
        {
            urlParams: {
                companyId
            }
        },
        cashedPayload
    )
}

function getWorksQualityNorm(companyId, worksQualityNormId) {
    return dataTransferWrap(
        ModulesMap.WORKS_QUALITY_NORMS,dtConfig[ModulesMap.WORKS_QUALITY_NORMS].getWorksQualityNorm,
        {
            urlParams: {
                companyId,
                worksQualityNormId
            }
        }
    )
}

function createWorksQualityNorm(companyId, data) {
    return dataTransferWrap(
        ModulesMap.WORKS_QUALITY_NORMS,dtConfig[ModulesMap.WORKS_QUALITY_NORMS].createWorksQualityNorm,
        {
            urlParams: {
                companyId
            },
            ...data
        }
    )
}

function putWorksQualityNorm(companyId, worksQualityNormId, data) {
    return dataTransferWrap(
        ModulesMap.WORKS_QUALITY_NORMS,dtConfig[ModulesMap.WORKS_QUALITY_NORMS].putWorksQualityNorm,
        {
            urlParams: {
                companyId,
                worksQualityNormId
            },
            ...data
        },
    )
}

function patchWorksQualityNorms(companyId, worksQualityNormId, data) {
    return dataTransferWrap(
        ModulesMap.WORKS_QUALITY_NORMS,dtConfig[ModulesMap.WORKS_QUALITY_NORMS].patchWorksQualityNorms,
        {
            urlParams: {
                companyId,
                worksQualityNormId
            },
            ...data
        }
    )
}

function deleteWorksQualityNorm(companyId, worksQualityNormId) {
    return dataTransferWrap(
        ModulesMap.WORKS_QUALITY_NORMS,dtConfig[ModulesMap.WORKS_QUALITY_NORMS].deleteWorksQualityNorm,
        {
            urlParams: {
                companyId,
                worksQualityNormId
            }
        }
    )
}

export default {
    getWorksQualityNorms,
    getWorksQualityNorm,
    createWorksQualityNorm,
    putWorksQualityNorm,
    patchWorksQualityNorms,
    deleteWorksQualityNorm,
}